import Vue from 'vue'
import { GET_INCUBATOR_REWARDS } from '../mutation-types.js'

export const getIncubatorRewards = ({ state, dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http.get('incubator_reward')
    .then(
      (response) => {
        dispatch(GET_INCUBATOR_REWARDS, response.json())
        resolve()
      },
      (response) => {
        reject()
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/incubatorRewardsActions.js